module.exports = __webpack_public_path__ + "img/folder.35b20510.svg";